import { OnInit, Component, transition, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import * as _ from 'lodash';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { BannerQuery, BannerItemQuery } from '@shared/queries';
import { LanguageService } from '@shared/services';
import { LoadingService } from '@shared/modules/loading';
import { ParseObject, BannerItem, Banner, BannerOption, Language, FileRef } from '@shared/data';

import { EditBannerItemComponent } from './../edit-banner-item';
import { EditBannerDataTableOptions } from './edit-banner.data-table-options';
import { EditBannerTranslation } from './edit-banner-translation';

@Component({
  moduleId: 'module.id',
  selector: 'edit-banner',
  styles: [require('./edit-banner.component.scss')],
  template: require('./edit-banner.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class EditBannerComponent implements OnInit, OnDestroy {
  public banner: Banner;
  public bannerOptions: BannerOption[];

  public options: EditBannerDataTableOptions;
  public error: Parse.Error;
  public bannerId: string;
  public isSaving: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private languageService: LanguageService,
    private modalService: NgbModal) {

    this.options = new EditBannerDataTableOptions();
    this.banner = new Banner();
    this.bannerOptions = BannerOption.options();
    this.banner.option = this.bannerOptions[0];
  }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.bannerId = params['id'];

      if (!this.bannerId) {
        return;
      }

      this.fetchBanner();
    });
  }

  public ngOnDestroy(): void {
    this.banner.revert();
  }

  // ===============================================================================================
  // Accessors
  // ===============================================================================================

  public set code(code: string) {
    this.banner.option = this.bannerOptions.find(b => b.code == code);
  }

  public get code(): string {
    return this.banner.code;
  }

  public get parentUrl(): string {
    return this.bannerId ? '../../' : '../';
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onAdd() {
    this.edit(new BannerItem());
  }

  public onRowSelect(row: number) {
    this.edit(this.banner.items[row]);
  }

  public onDelete(row: number) {
    this.banner.items.splice(row, 1);
  }

  public onSave(): void {
    this.loadingService.continue();
    this.isSaving = true;

    this.banner.save().then(
      result => {
        this.router.navigate([this.parentUrl], { relativeTo: this.route });
        this.isSaving = false;
      },
      error => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private fetchBanner(): void {
    let query = new BannerQuery()
      .includeTranslation([Banner.ITEMS_KEY, BannerItem.IMAGE_KEY].join('.'), this.languageService.defaultLang)
      .include(Banner.ITEMS_KEY);

    this.loadingService.continue();

    query.get(this.bannerId).then(
      (banner: Banner) => {
        this.banner = banner;
        this.loadingService.complete();
      },
      (error: Parse.Error) => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }

  private edit(item: BannerItem) {
    const modalRef = this.modalService.open(EditBannerItemComponent);
    let component: EditBannerItemComponent = modalRef.componentInstance;

    component.item = item;
    component.option = this.banner.option;

    modalRef.result.then(
      (item: BannerItem) => {
        this.banner.addUnique(Banner.ITEMS_KEY, item);

        this.loadingService.continue();

        item.save().then(
          result => {
            this.loadingService.complete();
          },
          error => {
            this.error = error;
            this.loadingService.complete();
          }
        )
      },
      error => {

      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+banner/edit-banner/edit-banner.component.ts